import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28887596"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "page-toolbar-filter__icon",
  "aria-hidden": "true"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bộ lọc", -1))
const _hoisted_3 = {
  class: "page-toolbar-filter__dropdown",
  role: "dialog",
  "aria-label": "Bộ lọc"
}
const _hoisted_4 = { class: "page-toolbar-filter__dropdown-head" }
const _hoisted_5 = { class: "page-toolbar-filter__dropdown-title" }
const _hoisted_6 = {
  class: "page-toolbar-filter__dropdown-title-icon",
  "aria-hidden": "true"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "page-toolbar-filters-slot",
  class: "page-toolbar-filter__dropdown-body"
}, null, -1))

import { onBeforeUnmount, onMounted, ref } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faChevronDown,
  faFilter,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { usePageToolbar } from '@/core/hooks/usePageToolbar';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageToolbarFilterDropdown',
  setup(__props) {

const { pageToolbar, filtersOpen, actionsOpen, approvalOpen } =
  usePageToolbar();
const rootRef = ref<HTMLElement | null>(null);

function toggleFilters() {
  const next = !filtersOpen.value;
  filtersOpen.value = next;
  if (next) {
    actionsOpen.value = false;
    approvalOpen.value = false;
  }
}

function onDocumentClick(event: MouseEvent) {
  if (!filtersOpen.value || !rootRef.value) {
    return;
  }
  const target = event.target as Node | null;
  if (target && !rootRef.value.contains(target)) {
    filtersOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', onDocumentClick, true);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', onDocumentClick, true);
});

return (_ctx: any,_cache: any) => {
  return (_unref(pageToolbar).showFilter)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "page-toolbar-filter",
        ref_key: "rootRef",
        ref: rootRef
      }, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["page-toolbar-filter__btn", { 'page-toolbar-filter__btn--open': _unref(filtersOpen) }]),
          onClick: toggleFilters
        }, [
          _createElementVNode("span", _hoisted_1, [
            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faFilter) }, null, 8, ["icon"])
          ]),
          _hoisted_2,
          _createVNode(_unref(FontAwesomeIcon), {
            icon: _unref(faChevronDown),
            class: _normalizeClass(["page-toolbar-filter__chevron", { 'page-toolbar-filter__chevron--open': _unref(filtersOpen) }])
          }, null, 8, ["icon", "class"])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faFilter) }, null, 8, ["icon"])
              ]),
              _createTextVNode(" Bộ lọc ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "page-toolbar-filter__close",
              title: "Đóng",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (filtersOpen.value = false))
            }, [
              _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faXmark) }, null, 8, ["icon"])
            ])
          ]),
          _hoisted_7
        ], 512), [
          [_vShow, _unref(filtersOpen)]
        ])
      ], 512))
    : _createCommentVNode("", true)
}
}

})